module.exports = __webpack_public_path__ + "static/img/dMRI2.f63e9ebe.png";